var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"deposit-status",class:{
    'progress-status': _vm.deposit.status === 'PENDING',
    'success-status': _vm.deposit.status === 'SUCCEEDED',
    'failure-status': _vm.deposit.status === 'FAILED',
    'canceled-status': _vm.deposit.status === 'CANCELED',
    'na-status': _vm.deposit.status === undefined,
  }},[_vm._v(" "+_vm._s(_vm.deposit.status ? _vm.$t('deposits.status.' + _vm.deposit.status) : _vm.$t('deposits.status.NOT_AVAILABLE'))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }